import cubeTexture1 from 'url:/img/lcdm/cubes/1.jpg';
import cubeTexture2 from 'url:/img/lcdm/cubes/2.jpg';
import cubeTexture3 from 'url:/img/lcdm/cubes/3.jpg';
import cubeTexture4 from 'url:/img/lcdm/cubes/4.jpg';
import cubeTexture5 from 'url:/img/lcdm/cubes/5.jpg';

let scene , camera, canvas, renderer;
let grabPoint;
let cubes = [];
let interactable = [];

const mouse = new THREE.Vector2();
const raycaster = new THREE.Raycaster();
let physicsWorld;
let clock;

let linePositions = [0, 0, 0, /**/ 0,0,0];
let line;

let directionalLight;

const cubeSettings = [
    {
        elem: document.querySelector('.cube.is-1'),
        pos: {x:0, y: 0, z: 0 },
        rot: new THREE.Euler(30, 0, 0),
        texture: cubeTexture1,
        active: true
    },
    {
        elem: document.querySelector('.cube.is-2'),
        pos: {x:0, y: 0, z: 0 },
        rot: new THREE.Euler(30, 0, 0),
        texture: cubeTexture2,
    },
    {
        elem: document.querySelector('.cube.is-3'),
        pos: {x:0, y: 0, z: 0 },
        rot: new THREE.Euler(30, 0, 0),
        texture: cubeTexture3,
    },
    {
        elem: document.querySelector('.cube.is-4'),
        pos: {x:0, y: 0, z: 0 },
        rot: new THREE.Euler(0, 0, 0),
        texture: cubeTexture4,
    },
    {
        elem: document.querySelector('.cube.is-5'),
        pos: {x:0, y: 0, z: 0 },
        rot: new THREE.Euler(0, 0, 0),
        texture: cubeTexture5,
        active: true
    }
]

const planElems = document.querySelectorAll('.shadow-panel');

window.addEventListener('load', start);

function getGameXY(bounds){
    let x = bounds.x;
    let y = bounds.y;

    //get relative to document
    x += window.pageXOffset;
    y += window.pageYOffset;

    //get relative to game axis
    x = x + canvas.clientWidth / -2;
    y = ( canvas.clientHeight / 2) - y;

    //center
    x += bounds.width / 2;
    y -= bounds.height / 2;

    return {x: x/camera.zoom, y: y/camera.zoom, height: bounds.height / camera.zoom, width: bounds.width / camera.zoom};
}

function updateCubeSettings(){
    for(let i = 0; i < cubeSettings.length; i++){
        const curCube = cubeSettings[i];
        const e = curCube.elem;
        if (!e) continue;
        const bounds = getGameXY(e.getBoundingClientRect());

        curCube.pos = new THREE.Vector3(bounds.x, bounds.y , 0);
    }
}

function createAndAddCubesContainer(){
    const element = document.querySelector('.puzzle');
    const bounds = element.getBoundingClientRect();
    const gameBounds = getGameXY(bounds);

    const min_x = gameBounds.x;
    const min_y = gameBounds.y;

    const w = 0.2;

    //Crystal
    const planeMaterial = new THREE.MeshBasicMaterial({
        color: 0xffffff,
        opacity: 0.2,
        transparent: true,
    });
    const planeGeometry = new THREE.PlaneBufferGeometry( gameBounds.width, gameBounds.height, 8, 8 );

    const crystal = new THREE.Mesh( planeGeometry, planeMaterial );

    crystal.position.set(min_x, min_y, 10);
    crystal.name = "NOCOLLIDE_CRYSTAL";
    scene.add(crystal);
    interactable.push(crystal);

    createBound("TOP_SHELF",min_x, min_y - w/2 + gameBounds.height / 2, 0, w, gameBounds.width, 100, 0x9c9c9c);
    createBound("BOTTOM_SHELF",min_x, min_y + w/2 - gameBounds.height / 2, 0, w, gameBounds.width*1.1, 100, 0x9c9c9c);
}

function createAndAddShadowPlanes(){
    const createShadowPlane = function (width, height, position, rotation, opacity = 0.5) {
        const planeGeometry = new THREE.PlaneBufferGeometry( width, height, 32, 32 );
        const planeMaterial =  new THREE.ShadowMaterial();

        planeMaterial.opacity = opacity;

        const plane = new THREE.Mesh( planeGeometry, planeMaterial );

        plane.position.copy(position);
        plane.rotation.copy(rotation);
        plane.receiveShadow = true;

        return plane;
    }

    const rot = new THREE.Euler(0, 0, 0);
    for(let i = 0; i < planElems.length; i++) {
        const e = planElems[i];
        const b = e.getBoundingClientRect();

        const pos = getGameXY(b);

        pos.z = -1;
        const shadowPlane = createShadowPlane(pos.width, pos.height, pos, rot);
        scene.add(shadowPlane);
    }
}

function init() {
    clock = new THREE.Clock();

    canvas = document.getElementById( 'c' );

    renderer = new THREE.WebGLRenderer( { canvas: canvas, alpha: true } );

    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap

    camera = new THREE.OrthographicCamera( 0,0,0,0, 1, 2000 );

    camera.position.z = 100;
    camera.zoom = 100;

    updateCameraSize();

    updateCubeSettings();

    scene = new THREE.Scene();
    scene.add( new THREE.AmbientLight( 0x505050 ) );

    directionalLight = new THREE.DirectionalLight( 0xffffff, 1 );
    directionalLight.position.set( -2, -5, 30 );
    directionalLight.castShadow = true;
    directionalLight.shadow.camera = camera.clone();
    directionalLight.shadow.camera.near = 30;
    directionalLight.shadow.camera.far = 40;
    directionalLight.shadow.mapSize.width = directionalLight.shadow.mapSize.height = 512;
    scene.add( directionalLight );

    const lineGeometry = new THREE.BufferGeometry();

    linePositions = new Float32Array( 2 * 3 ); // 3 vertices per point
    lineGeometry.setAttribute( 'position', new THREE.BufferAttribute( linePositions, 3 ) );
    lineGeometry.setDrawRange( 0, 2 );

    line = new THREE.Line( lineGeometry,  new THREE.LineBasicMaterial( { color: 0xffffff , linewidth: scaleByPixelRatio(2)}) );

    scene.add( line );

    const geometry = new THREE.BoxBufferGeometry( 1, 1, 1 );

    grabPoint = new THREE.Mesh( new THREE.SphereGeometry( 1, 16, 16 ), new THREE.MeshBasicMaterial( { color: 0xffffff } ) );
    grabPoint.scale.set(0.1, 0.1,0.1);

    grabPoint.visible = false;

    scene.add(grabPoint);

    function createCube(quat, scale, pos, i, mass, textureUrl) {
        const texture = new THREE.TextureLoader().load(textureUrl);
        const object = new THREE.Mesh(geometry, new THREE.MeshBasicMaterial({map: texture}));

        object.position.set(pos.x, pos.y, pos.z);
        object.scale.set(scale.x, scale.y, scale.z);
        object.quaternion.set(quat.x, quat.y, quat.z, quat.w);

        let colShape = new CANNON.Box(new CANNON.Vec3(scale.x * 0.5, scale.y * 0.5, scale.z * 0.5));

        let body = new CANNON.Body({
            mass: mass, // kg
            position: new CANNON.Vec3(pos.x, pos.y, pos.z), // m
            shape: colShape,
            quaternion: quat
        });
        physicsWorld.addBody(body);

        object.name = "cube" + i;
        object.userData.physicsBody = body;
        object.castShadow = true;

        return object;
    }

    for ( let i = 0; i < cubeSettings.length; i ++ ) {
        const config = cubeSettings[i] || {pos: undefined, rot: undefined};

        let pos = config.pos;
        let rot = config.rot || new THREE.Euler(0, 0, 0);
        let scale = {x: 1, y:1, z:1};
        const quat = new THREE.Quaternion();
        let mass = 1;

        quat.setFromEuler(rot);

        const size = document.querySelector('.cube').getBoundingClientRect().width / camera.zoom;

        scale.x = size;
        scale.y = size;
        scale.z = size;

        if (!pos) {
            pos = {};
            pos.x = -4 + i * (size + .1);
            pos.y = 2;
            pos.z = 0;
        }

        const object = createCube(quat, scale, pos, i, mass, config.texture);

        if (!config.active)
            object.userData.physicsBody.sleep();
        object.userData.domElem = config.elem;

        scene.add(object);
        cubes.push( object );
        interactable.push( object );
    }

    createAndAddCubesContainer();

    createAndAddShadowPlanes();

    window.lastWidth = window.innerWidth;

    //HACK: Reloads page on resize... Too hard to recreate physics+render worlds u.u"
    window.addEventListener( 'resize', () => {
        if (window.lastWidth === window.innerWidth){
            updateSize();
            return;
        }

        if (window.RT) clearTimeout(window.RT);
        window.RT = setTimeout(() => window.location.reload(false), 500);
    }, false );

    window.addEventListener( 'mousemove', onMouseMove, false );
    window.addEventListener( 'dragstart', onMouseMove, false );
    window.addEventListener( 'mousedown', onMouseDown, {passive: false} );
    window.addEventListener( 'mouseup', onMouseCancel, false );

    window.addEventListener( 'touchstart', onMouseDown, {passive: false} );
    window.addEventListener( 'touchend', onMouseCancel, false );
    window.addEventListener( 'touchmove', onMouseMove, false );
}

function createBound(name, x, y, z, height, width, depth, color, friction = 1){
    let colShape = new CANNON.Box(new CANNON.Vec3(width/2, height/2, depth/2));

    let body = new CANNON.Body({
        mass: 0 , //Static
        position: new CANNON.Vec3(x, y, z), // m
        shape: colShape
    });
    physicsWorld.addBody(body);

    (function() {
        //body.setFriction(friction);
        physicsWorld.addBody(body);

        const geometry = new THREE.BoxBufferGeometry( 1, 1, 1 );
        const object = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial( { color: color } ) );

        object.scale.set(width, height, depth);

        object.position.x = x;
        object.position.y = y;
        object.position.z = z;

        object.name = name;
        object.userData.body = body;

        scene.add(object);
    })();
}

function removeEntity (name) {
    const selectedObject = scene.getObjectByName(name);
    if (selectedObject) {
        if (selectedObject.userData.body)
            physicsWorld.removeBody(selectedObject.userData.body);
        scene.remove(selectedObject);
    }
}

function CreateBounds(){
    const min_x = camera.left / camera.zoom;
    const max_x = camera.right / camera.zoom;
    const min_y = camera.bottom / camera.zoom;
    const max_y = camera.top / camera.zoom;

    let w = 2;

    removeEntity("TOP");
    removeEntity("BOTTOM");
    removeEntity("LEFT");
    removeEntity("RIGHT");

    createBound("TOP",min_x - w/2, 0, 0, (max_y - min_y), w, 100, 0xffffff);
    createBound("BOTTOM", max_x + w/2, 0, 0, (max_y - min_y), w, 100, 0x0000ff);

    createBound("LEFT",0, max_y + w/2, 0, w, (max_x - min_x), 100, 0xff0000);
    createBound("RIGHT",0, min_y - w/2, 0, w, (max_x - min_x), 100, 0x00ff00);
}

function updateCameraSize(){
    camera.left = canvas.clientWidth / - 2;
    camera.right = canvas.clientWidth / 2;
    camera.top = canvas.clientHeight / 2;
    camera.bottom = canvas.clientHeight / - 2;
    camera.updateProjectionMatrix();
}

function resizeRendererToDisplaySize(renderer) {
    const r = renderer.domElement;
    const width  = canvas.clientWidth;
    const height = canvas.clientHeight;
    const needResize = r.width !== width || r.height !== height;

    if (needResize)
        renderer.setSize(width, height, false);

    return needResize;
}

function updateSize() {
    if (resizeRendererToDisplaySize(renderer)) {
        updateCubeSettings();
        updateCameraSize();
        CreateBounds();
    }
}

function animate() {
    render();
    requestAnimationFrame( animate );
}

let intersection = undefined;
let constraint;
let pickedBody;

const mousePickClamping = 30;

function onMouseDown( event ) {
    updateMouse(event);
    updateIntersection(mouse);

    if (!intersection) return;

    event.preventDefault();

    const inter = intersection;
    const obj = inter.object;

    pickedBody = obj.userData.physicsBody;

    const localPoint = obj.worldToLocal(inter.point)
    const localPivot = new CANNON.Vec3(localPoint.x * obj.scale.x, localPoint.y * obj.scale.y, localPoint.z * obj.scale.z);
    constraint = new CANNON.PointToPointConstraint(pickedBody, localPivot, jointBody, new CANNON.Vec3(), 20);
    physicsWorld.addConstraint(constraint);

    grabPoint.visible = true;
    grabPoint.position.copy(inter.point);
    grabPoint.parent = obj;
}

function onMouseCancel( event ) {
    if (constraint){
        physicsWorld.removeConstraint(constraint);
        constraint = undefined;
        //pickedBody.setActivationState(1);
        pickedBody = undefined;
        grabPoint.visible = false;
    }
}

function updateMouse(event){
    const touchEv = event.touches && event.touches[0];
    const changedTouchEv = event.changedTouches && event.changedTouches[0];
    const touch = touchEv || changedTouchEv || event;

    const documentBounds = document.documentElement.getBoundingClientRect();

    mouse.x = ( touch.pageX / documentBounds.width ) * 2 - 1;
    mouse.y = - ( touch.pageY / documentBounds.height ) * 2 + 1;

    mouse.nonPageX = ( touch.clientX / documentBounds.width ) * 2 - 1;
    mouse.nonPageY = - ( touch.clientY / documentBounds.height ) * 2 + 1;
}

function updateIntersection(mouse){
    raycaster.setFromCamera( mouse, camera );

    const newIntersections = raycaster.intersectObjects( interactable );

    intersection = undefined;

    if (newIntersections.length > 0 && !newIntersections[0].object.name.startsWith("NOCOLLIDE")){
        intersection = newIntersections[0];
    }

    if (intersection){
        canvas.style.pointerEvents = 'all';
        canvas.style.cursor = 'pointer';
    }else if (!constraint){
        canvas.style.pointerEvents = 'none';
        canvas.style.cursor = 'auto';
    }
}

function addMouseConstraint(x,y,z,body) {
    // The cannon body constrained by the mouse joint
    constrainedBody = body;

    // Vector to the clicked point, relative to the body
    var v1 = new CANNON.Vec3(x,y,z).vsub(constrainedBody.position);

    // Apply anti-quaternion to vector to tranform it into the local body coordinate system
    var antiRot = constrainedBody.quaternion.inverse();
    pivot = antiRot.vmult(v1); // pivot is not in local body coordinates

    // Move the cannon click marker particle to the click position
    jointBody.position.set(x,y,z);

    // Create a new constraint
    // The pivot for the jointBody is zero
    mouseConstraint = new CANNON.PointToPointConstraint(constrainedBody, pivot, jointBody, new CANNON.Vec3(0,0,0));

    // Add the constriant to world
    world.addConstraint(mouseConstraint);
}

function onMouseMove( event ) {
    updateMouse(event);
    updateIntersection(mouse);

    let v = new THREE.Vector3( mouse.x, mouse.y, -1 )
    let {x, y, z} = v.unproject(camera);

    jointBody.position.x = x;
    jointBody.position.y = y;

    if (constraint) {
        constraint.update();

        canvas.style.cursor = 'move';

        if (mouse.nonPageY > .8){
            window.scroll(window.scrollX, window.scrollY - 10);
            updateMouse(event);
            updateIntersection(mouse);
        }
    }
}

let frame_counter = 0;
let first_time = true;

function render(){
    const deltaTime = clock.getDelta();

    const time = Date.now() * 0.0005;

    directionalLight.position.y = Math.cos( time * 3 ) * .75 - 5;

    ClampPositions();

    if (constraint) {
        if (first_time){
            ga('send', {
                hitType: 'event',
                eventCategory: 'LCDM',
                eventAction: 'start'
            });

            first_time = false;
        }
        let v = new THREE.Vector3( mouse.x, mouse.y, -1 )
        let {x, y, z} = v.unproject(camera);
        let grabPointPos = new THREE.Vector3();

        grabPointPos.setFromMatrixPosition(grabPoint.matrixWorld);

        let i = 0;

        linePositions[i++] = grabPointPos.x;
        linePositions[i++] = grabPointPos.y;
        linePositions[i++] = grabPointPos.z;

        linePositions[i++] = x;
        linePositions[i++] = y;
        linePositions[i++] = z;

        line.geometry.attributes.position.needsUpdate = true;
        line.geometry.computeBoundingSphere();
        line.visible = true;
    }else{
        line.visible = false;
    }

    updatePhysics( deltaTime );

    if (!solved){
        solved = CheckSolution();

        if (solved) {
            ga('send', {
                hitType: 'event',
                eventCategory: 'LCDM',
                eventAction: 'solved'
            });
            PlaySolvedMagic();
        }
    }else{
        if (frame_counter++ % 300 === 0) {
            for (let i = 0; i < cubes.length; i++) {
                const body = cubes[i].userData.physicsBody;
                const force = Math.random()*50;
                const v = new THREE.Vector3(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5);
                v.normalize();
                v.multiplyScalar(force);

                const [vx, vy, vz] = [v.x, v.y, 0];

                //body.activate();
                body.applyLocalImpulse(v, new CANNON.Vec3(0, 0, 0));
            }
        }
        window.fluidsMovePointers(PreparePointers());
    }

    renderer.render( scene, camera );
}

window.solve = () => {solved = true; PlaySolvedMagic()};

let solved = false;

function PreparePointers(){
    const cubePointers = [];

    for(let i = 0 ; i < cubes.length; i++){
        const cube = cubes[i];
        const pos = cube.position;

        cubePointers.push({
            x: (pos.x * camera.zoom + camera.right),
            y: (pos.y * camera.zoom + camera.top),
            identifier: cube.name
        });
    }

    return cubePointers;
}

function PlaySolvedMagic(){
    removeEntity("TOP_SHELF");
    removeEntity("BOTTOM_SHELF");
    removeEntity("NOCOLLIDE_CRYSTAL");
    window.vantabg.destroy();
    window.enableFluids();
    const cubesPointers = PreparePointers();
    window.fluidsStartPointers(cubesPointers);
    gravity = 0;
}

function CheckSolution(){
    const element = document.querySelector('.puzzle');
    const bounds = element.getBoundingClientRect();
    const gameBounds = getGameXY(bounds);

    const min_x = gameBounds.x - gameBounds.width / 2;
    const max_x = gameBounds.x + gameBounds.width / 2;
    const min_y = gameBounds.y - gameBounds.height / 2;
    const max_y = gameBounds.y + gameBounds.height / 2;

    const solution = "12345";
    const trySol = [];

    for(let i = 0 ; i < cubes.length; i++){
        const cube = cubes[i];

        if (cube.position.x > max_x || cube.position.x < min_x){
            return false;
        }
        if (cube.position.y > max_y || cube.position.y < min_y){
            return false;
        }
        trySol.push([i+1, cube.position.x])
    }

    trySol.sort((a, b) => a[1] - b[1]);
    const proposedSol = trySol.map((e) => e[0].toString()).join("");

    return solution === proposedSol;
}

function ClampPositions(){
    for(let i = 0; i < cubes.length; i++){
        const obj = cubes[i];
        const body = obj.userData.physicsBody;

        const position = obj.position;

        position.z = 0;
        position.x = Math.min(Math.max(camera.left / camera.zoom, position.x), camera.right / camera.zoom);
        position.y = Math.min(Math.max(camera.bottom / camera.zoom, position.y), camera.top / camera.zoom);

        body.position.set(position.x, position.y, position.z);
    }
}

let gravity = undefined;
let jointBody = undefined;

function setupPhysicsWorld(){
    if (!gravity)
        gravity = -9.82;

    physicsWorld = new CANNON.World();
    physicsWorld.quatNormalizeSkip = 0;
    physicsWorld.quatNormalizeFast = false;

    physicsWorld.broadphase = new CANNON.NaiveBroadphase();
    physicsWorld.allowSleep = true;
    physicsWorld.gravity.set(0, gravity, 0); // m/s²

    jointBody = new CANNON.Body({ mass: 0 });
    physicsWorld.add(jointBody)
}

function start(){
    setupPhysicsWorld();

    init();
    updateSize();
    CreateBounds();
    animate();
}
const fixedTimeStep = 1.0 / 60.0; // seconds
const maxSubSteps = 3;

function updatePhysics( dt ){
    // Update gravity
    physicsWorld.gravity.set(0, gravity, 0)
    // Step world
    physicsWorld.step(fixedTimeStep, dt, maxSubSteps);

    // Update rigid bodies
    for ( let i = 0; i < cubes.length; i++ ) {
        let objThree = cubes[ i ];
        let body = objThree.userData.physicsBody;

        let p = body.position;
        let q = body.quaternion;
        objThree.position.set( p.x, p.y, p.z );
        objThree.quaternion.set( q.x, q.y, q.z, q.w );
    }
}

const burger = document.querySelector('#navbar-burger-id');

burger.addEventListener('click', function(){
    if (burger.classList.contains('is-active')){
        gravity = -9.82;
        //for(let i = 0; i < cubes.length; i++)
        //    cubes[i].userData.physicsBody.activate(true);
    }else{
        if (!solved) return;
        gravity = 0;
    }
}, false)

function scaleByPixelRatio (input) {
    let pixelRatio = window.devicePixelRatio || 1;

    return Math.floor(input * pixelRatio);
}